import React, { useState, useEffect } from "react";
import { Image_Url } from "../../constants/imageUrl/ImageUrl";
import Header from "../../component/Header/Header";
import Footer from "../../component/Footer/Footer";
import { useNavigate } from "react-router-dom";
import Sidebar from "../Sidebar/index";
import "./partorderlist.scss";
import PartsOrderTextField from "../../component/PartsOrderTextfieldComponent/PgmTextField";
import Pagination from "../../component/Pagination/PgmTextField";
import { orderAction, orderListSort } from "../../actions/orderAction";
import { useDispatch } from "react-redux";
import PartorderlistButtons from "../../component/PartorderslistButtons";
import Loader from "../../component/loaderComponent/Loader";
import { safeEncode } from "../../common/encoder";
import { FaAngleUp, FaAngleDown } from "react-icons/fa";
import { IoIosInformationCircleOutline } from "react-icons/io";
import Cookies from "js-cookie";
import {
  orderListSearchInputAction,
  orderListPageInputAction,
} from "../../actions/orderAction";
import { useSelector } from "react-redux";
import { HTTP_STATUS } from "../../constants/httpstatus/HttpsStatus";
import NodataFound from "../../component/NodataFound";
import { useTranslation } from "react-i18next";
import { hasPermission } from "../../utils/permissionUtils";
import { PERMISSIONS } from "../../constants/permissions/Permissions";

function PartOrderList() {

  const searchData = useSelector((state) => state?.orderListSearch);
  const pageData = useSelector((state) => state?.orderListPage);
  var paginationCount = 15;
  const [orderList, setOrderList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [count, setCount] = useState(1);
  const [page, setPage] = useState(pageData?.page);
  const [startIndex, setStartIndex] = useState(1);
  const [selectedStatusOptions, setSelectedStatusOptions] = useState(
    searchData?.searchvaluedata?.statusValue || []
  );
  const [searchInput, setSearchInput] = useState(
    searchData?.searchvaluedata?.searchdata || ''
  );
  const [fromDate, setFromDate] = useState(
    searchData?.searchvaluedata?.from_date || ''
  );
  const [toDate, setToDate] = useState(searchData?.searchvaluedata?.to_date || '');
  const [totalPrice, setTotalPrice] = useState(0);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [currency, setCurrency] = useState('')

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { i18n, t } = useTranslation();
  const language = Cookies.get("language");

  const options = [
    { value: 'new', label: t('partorderlist.new') },
    { value: 'acknowledged', label: t('popupack.acknowledge') },
    { value: 'dispatched', label: t('part_list_dispatch.dispatched') },
    { value: 'completed', label: t('partlist_delevered.completed') },
  ];
  useEffect(() => {
    OrderListData();
    handleChangeLanguage(language);
  }, [page]);

  useEffect(() => {
    if (searchInput?.length === 0) {
      OrderListData()
    }
  }, [searchInput])

  const handleChangeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  const partcatelogueview = (Id, status) => {
    window.scroll(0, 0);
    const encodeid = safeEncode(Id);
    if (typeof status !== "string") return;
    
    const lowerStatus = status?.toLowerCase();
    if (lowerStatus === "new" || lowerStatus === "nueva") {
      navigate(`/parts_lists/${encodeid}`);
    } else if (lowerStatus === "acknowledged" || lowerStatus === "reconocer") {
      navigate(`/parts_lists_acks/${encodeid}`);
    } else if (lowerStatus === "dispatched" || lowerStatus === "enviada") {
      navigate(`/parts_lists_dispatch/${encodeid}`);
    } else if (lowerStatus === "completed" || lowerStatus === "terminada") {
      navigate(`/parts_lists_delevered/${encodeid}`);
    }
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    dispatch(orderListPageInputAction(value));
  };

const handleSearchInputChange = (event, name) => {
  let value = name === "searchdata" ? event.target.value.trimStart() : event.target.value;

  let updatedStatusOptions = name === "statusValue" ? value : selectedStatusOptions;

  const updatedSearchData = {
    from_date: name === "from_date" ? value : fromDate,
    to_date: name === "to_date" ? value : toDate,
    searchdata: name === "searchdata" ? value : searchInput,
    statusValue: updatedStatusOptions,
  };

  if (name === "from_date") setFromDate(value);
  if (name === "to_date") setToDate(value);
  if (name === "searchdata") setSearchInput(value);
  if (name === "statusValue") setSelectedStatusOptions(updatedStatusOptions);

  dispatch(orderListSearchInputAction(updatedSearchData));

  const isAllFiltersCleared = 
    !updatedSearchData.from_date && 
    !updatedSearchData.to_date && 
    !updatedSearchData.searchdata && 
    updatedSearchData.statusValue.length === 0;

  if (isAllFiltersCleared) {
    setPage(1);
    dispatch(orderListPageInputAction(1));
    OrderListData();
  }
};

  async function OrderListData(sortdata, columnNumber) {
    const statusValue = selectedStatusOptions?.join(", ");
    const newStartIndex = (page - 1) * paginationCount + 1;
    setStartIndex(newStartIndex);
    setIsLoading(true);
    let response = await dispatch(
      orderAction(page, fromDate, toDate, searchInput, statusValue, sortdata, columnNumber)
    );
    if (response?.status === HTTP_STATUS.SUCCESS) {
      setCount(Math.ceil(response?.data?.data?.count / paginationCount));
      setOrderList(response?.data?.data?.results);
      setTotalPrice(response?.data?.data?.total_price);
      setTotalQuantity(response?.data?.data?.total_quantity);
      setCurrency(response?.data?.data?.currency)
      setIsLoading(false);
    } else if (response === undefined) {
      setIsLoading(false);
    }
  }

  const sortingData = (sortitem, columnNumber) => {
    dispatch(orderListSort(columnNumber, sortitem));
    OrderListData(sortitem, columnNumber)
  }

  async function filterSearch(fromdate, todate, searchValue, status) {
    const defaultPage = 1;
    setPage(1);
    dispatch(orderListPageInputAction(1));

    if (!fromdate && !todate && searchValue === "" && status.length === 0) {
      OrderListData();
      return;
    }

    const statusValue = status?.join(", ");
    setIsLoading(true);
    let response = await dispatch(
      orderAction(defaultPage, fromdate, todate, searchValue, statusValue)
    );
    if (response?.status === HTTP_STATUS.SUCCESS) {
      setCount(Math.ceil(response?.data?.data?.count / paginationCount));
      setTotalPrice(response?.data?.data?.total_price);
      setTotalQuantity(response?.data?.data?.total_quantity);
      setCurrency(response?.data?.data?.currency)
      setOrderList(response?.data?.data?.results);
      setIsLoading(false);
    }
    else if (response === undefined) {
      setIsLoading(false);
    }
  }

  return (
    <div className="partlist_containers">
      <div className="partslist_container">
        <div className="partslistmain">
          <div className="header_border">
            <p className="pgm-list-header-text">TVS &gt; {t('partlist.partslist')}</p>
          </div>
          <div className="partsorderbuttons">
            <PartorderlistButtons fromDate={fromDate} toDate={toDate} />
          </div>
          <PartsOrderTextField
            filterSearch={filterSearch}
            searchInput={searchInput}
            options={options}
            selectedStatusOptions={selectedStatusOptions}
            fromDate={fromDate}
            toDate={toDate}
            handleSearchInputChange={handleSearchInputChange}
          />
          <div className="pagination_margin">
            {isLoading ? (
              <Loader />
            ) : (
              <>
                {(totalQuantity != null && totalPrice != null) && (
                  <div className="total-summary">
                    <div className="total-quantity">
                      <span>{t('partorderlist.totalQuantity')}: {totalQuantity}</span>
                    </div>
                    <div className="total-price">
                      <span>{t('partorderlist.totalPrice')}: {currency} {totalPrice.toFixed(2)}</span>
                    </div>
                  </div>
                )}
                <div className="tabledata">
                  {orderList?.length > 0 ? (
                    <table className="table">
                      <tr>
                        <th className="tablesth"> {t('pgmlist.sNo')}</th>
                        <th className="tablesth flex_updown">
                          {t('partorderlist.orderno')}
                          <span>
                            <FaAngleUp onClick={() => sortingData("asc", "order_number")} />
                            <FaAngleDown onClick={() => sortingData("desc", "order_number")} />
                          </span>
                        </th>
                        <th className="tablesth">{t('addpartner.name')}</th>
                        <th className="tablesth">{t('parts_list.quantity')}</th>
                        <th className="tablesth">{t('partlist.price')}</th>
                        <th className="tablesth">{t('partorderlist.status')}</th>
                        <th className="tablesth">{t('common.city')}</th>
                        <th className="tablesth">{t('common.provinceState')}</th>
                        <th className="tablesth">{t('partorderlist.orderdate')}</th>
                        <th className="tablesth">{t('partorderlist.orderBy')}</th>
                        {hasPermission(PERMISSIONS.CAN_VIEW_ORDER_DETAILS) &&(
                          <th className="tablesth"></th>
                        )}
                      </tr>

                      {orderList?.map((data, ind) => (
                        <tr key={data?.id}>
                          <td className="tabletd">{ind + startIndex}</td>
                          <td className="tabletd">{data?.order_number}</td>
                          <td className="tabletd show-data" title={data?.name}>{data?.name}</td>
                          <td className="tabletd">{data?.quantity}</td>
                          <td className="tabletd">{data?.price}</td>
                          <td className="tabletd">{data?.status} </td>
                          <td className="tabletd show-data" title={data?.city}>{data?.city} </td>
                          <td className="tabletd show-data" title={data?.province}>{data?.province} </td>
                          <td className="tabletd"> {data?.order_date}</td>
                          <td className="tabletd">{data?.order_by}
                            <span>
                              <IoIosInformationCircleOutline
                                title={`${data?.email || ''}${data?.email && data?.mobile_number ? '\n' : ''}${data?.mobile_number || ''}`}
                                className="information-icon"
                              />
                            </span>
                          </td>
                          {hasPermission(PERMISSIONS.CAN_VIEW_ORDER_DETAILS) && (
                          <td
                            className="tabletd_view"
                            onClick={() => { partcatelogueview(data?.id, data?.status_slug); }}
                          >
                            {t('common.view')}
                          </td>
                          )}
                        </tr>
                      ))}
                    </table>
                  ) : (
                    <NodataFound />
                  )}
                </div>
              </>
            )}
            <div className="pagination-div">
              <Pagination
                count={count}
                page={page}
                handlePageChange={handlePageChange}
              />
            </div>
          </div>
          <div className="footer_div">
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PartOrderList;
